import { Box, Button, Dialog, Portal, Stack } from '@chakra-ui/react'
import { Field, Formik } from 'formik'
import { Form, InputForm } from 'uikit'
import * as Yup from 'yup'
import { useSettingsFetch } from './services/useSettingsFetch'
import { useSettingsUpdate } from './services/useSettingsUpdate'
import { useEffect } from 'react'

const formSchema = Yup.object({
  paymentsInterval: Yup.number()
    .integer('invalid decimal')
    .min(0, 'Min')
    .required('Заполните поле'),
})

export const PaymentsIntervalSettings = ({ isOpen, onClose }) => {
  const { refetch: getSettings, isPending: isLoadingFetch, data } = useSettingsFetch()
  const { mutate: updateSettings, isPending: isLoadingUpdate } = useSettingsUpdate()

  useEffect(() => {
    if (isOpen) {
      getSettings()
    }
  }, [isOpen])

  const handleForm = (values) => {
    const payload = {
      paymentsInterval: Number(values.paymentsInterval),
    }
    updateSettings({ id: data?.id, data: payload }, {
      onSuccess: () => {
        onClose()
      }
    })
  }

  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Интервал между переводами</Dialog.Title>
              <Dialog.CloseTrigger />
            </Dialog.Header>
            <Dialog.Body>
              <Formik
                enableReinitialize
                validationSchema={formSchema}
                initialValues={{
                  paymentsInterval: data?.paymentsInterval ? String(data?.paymentsInterval) : '0',
                }}
                onSubmit={handleForm}
              >
                {(props) => (
                  <Form onSubmit={props.handleSubmit}>
                    <Stack gap={4}>
                      <Field
                        name="paymentsInterval"
                        label="Время в секундах"
                        component={InputForm}
                        placeholder="0"
                      />
                    </Stack>
                    <Box pt="30px">
                      <Button
                        type="submit"
                        colorPalette="orange"
                        loading={isLoadingUpdate || isLoadingFetch}
                      >
                        Сохранить
                      </Button>
                    </Box>
                  </Form>
                )}
              </Formik>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
